import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { Steps } from "primereact/steps";
import FormCrearSubproductoFicha from "./FormCrearSubproductoFicha";


const FormEditarSubproducto = ({
    showEditDialog,
    setShowEditDialog,
    setSubproducto,
    descripcion,
    setDescripcion,
    handleSaveSubproducto,
    fichaRef,
    id,
}) => {
    const [activeStep, setActiveStep] = useState(0);
    const stepsItems = [{ label: "Subproducto", command: () => setActiveStep(0) },{ label: "Ficha técnica", command: () => setActiveStep(1) },];
    const handleStepChange = (e) => {setActiveStep(e.index);};

    const limpiarFormulario = () => {
        setSubproducto({ 
            descripcion: ""
        });
        setShowEditDialog(false);
    };

    const handleSaveClick = async () => {
        try {
            // Capturar datos de la ficha ANTES de guardar
            let fichaData = null;
            if (fichaRef && fichaRef.current) {
                fichaData = fichaRef.current.getData();
            }
            await handleSaveSubproducto(fichaData);
        } catch (error) {
            console.error("Error al guardar:", error);
            alert("Error al actualizar el subproducto: " + error.message);
        }
    };

    const footerEditarProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded"
                />
                <Button
                    label="Guardar"
                    icon="pi pi-save"
                    onClick={handleSaveClick}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={showEditDialog}
                className="p-fluid product-dialog"
                onHide={limpiarFormulario}
                footer={footerEditarProd()}
                header="Editar Tipo Subproducto"
            >
                <Steps 
                    model={stepsItems} 
                    activeIndex={activeStep} 
                    onSelect={handleStepChange}
                    className="cursor-pointer"
                    style={{ cursor: 'pointer' }}
                    readOnly={false}
                />
                
                <div className="card" style={{ display: activeStep === 0 ? 'block' : 'none' }}>
                    <h6 className="mb-3">
                        Información del Subproducto
                    </h6>

                    <span className="p-float-label mt-2 mb-3">
                        <InputText
                            id="descripcion"
                            value={descripcion}
                            onChange={(e) =>setDescripcion(e.target.value.toUpperCase())}
                            className="p-inputtext-lg"
                            placeholder="Ingrese la descripción del producto"
                            max={35}
                        />
                        <label htmlFor="descripcion"><i className="pi pi-file-edit mr-2"></i>Descripción</label>
                    </span>

                    {/* Navegación entre steps */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="" onClick={() => setActiveStep(1)}/>
                    </div>
                </div>

                <div className="card" style={{ display: activeStep === 1 ? 'block' : 'none' }}>
                    <div className="flex-space-between">
                        <FormCrearSubproductoFicha 
                            ref={fichaRef} 
                            idSubproducto={id} 
                            isEditing={true} 
                        />
                        <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default FormEditarSubproducto;
